import Login from './components/pages/Login';
import {Route, Routes} from 'react-router';
import AuthenticatedApp from './components/AuthenticatedApp';
import Reports from "./components/pages/Reports";
import ReportDetail from "./components/pages/ReportDetail/ReportDetail";
import { Users } from './components/pages/Users';
import {UserReviewList} from "./components/pages/UserReviewList";
import {Navigate} from "react-router-dom";
import UserDetail from "./components/pages/UserDetail/UserDetail";
import UserReviewDetail from "./components/pages/UserReview/UserReviewDetail";
import {ActivationList} from "./components/pages/Activations/ActivationList";
import {ActivationEdit} from "./components/pages/Activations/ActivationEdit";
import { DateCardsOrdersList } from './components/pages/DateCards/DateCardsList';
import { DateCardsDeliveredList } from './components/pages/DateCards/DateCardsDeliveredList';
import { PendingDateCardList } from './components/pages/DateCards/PendingDateCardList';
import { DigitalDateCardsList } from './components/pages/DigitalDateCards/DigitalDateCardsList';
import { IdReviewList } from './components/pages/IdReviewList';
import IdReviewDetail from './components/pages/UserReview/IdReviewDetail';
import {BgcReviewList} from './components/pages/BgcReviewList';
import {DateCardDesignsList} from "./components/pages/DateCardDesigns/DateCardDesignsList";
import {DateCardDesignAdd} from "./components/pages/DateCardDesigns/DateCardDesignAdd";

function App() {
    return (
        <div className="App">
            <Routes>
                <Route element={<AuthenticatedApp/>}>
                    <Route path={'/reports'} element={<Reports/>}/>
                    <Route path={'/reports/:reportId'} element={<ReportDetail/>}/>
                    <Route path={'/users'} element={<Users/>}/>
                    <Route path={'/users/:userId'} element={<UserDetail/>}/>
                    <Route path={'/user-review'} element={<UserReviewList/>}/>
                    <Route path={'/id-review'} element={<IdReviewList/>}/>
                    <Route path={'/bgc-review'} element={<BgcReviewList/>}/>
                    <Route path={'/user-review/:userId'} element={<UserReviewDetail/>}/>
                    <Route path={'/id-review/:userId'} element={<IdReviewDetail/>}/>
                    <Route path={'/activations'} element={<ActivationList/>}/>
                    <Route path={'/activations/add'} element={<ActivationEdit/>}/>
                    <Route path={'/activations/:activationId'} element={<ActivationEdit/>}/>
                    <Route path={'/date-cards'} element={<DateCardsOrdersList/>}/>
                    <Route path={'/delivered-cards'} element={<DateCardsDeliveredList/>}/>
                    <Route path={'/pending-cards'} element={<PendingDateCardList/>}/>
                    <Route path={'/digital-date-cards'} element={<DigitalDateCardsList/>}/>
                    <Route path={'/date-card-designs'} element={<DateCardDesignsList/>}/>
                    <Route path={'/date-card-designs/add'} element={<DateCardDesignAdd/>}/>
                    <Route path={'*'} element={<Navigate to={'/reports'}/>}/>
                </Route>
                <Route path={"/login"} element={<Login/>}/>
            </Routes>
        </div>
    );
}

export default App;
